import React, { Fragment } from "react";

function PageNotFound() {
  return <Fragment>Erro</Fragment>;
}

export default PageNotFound;
